import { render, staticRenderFns } from "./goods-switch.vue?vue&type=template&id=7dae8adb&"
import script from "./goods-switch.vue?vue&type=script&lang=js&"
export * from "./goods-switch.vue?vue&type=script&lang=js&"
import style0 from "./goods-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports